import Web3 from 'web3'
import { Pool } from '../../abi/abi'
import { absoluteMaxPrice } from '../../config'
import { Swap } from '../../logic/swaps/Swap'
import { Address } from '../../utils/types'

export class SwapApi {
  poolContract: any

  constructor(
    public web3: Web3,
    public account: Address,
    public pool: Address
  ) {
    // @ts-ignore  Pool abi type is not totally correct, but it's working
    this.poolContract = new web3.eth.Contract(Pool, this.pool)
  }

  private _amountOutGivenInMMM(swap: Swap) {
    const { inAmountWei, tokenIn, tokenOut } = swap

    return this.poolContract.methods.getAmountOutGivenInMMM(
      tokenIn.address,
      inAmountWei,
      tokenOut.address,
      0,
      absoluteMaxPrice
    )
  }

  async estimateTokenOutAmountCall(swap: Swap) {
    const result = await this._amountOutGivenInMMM(swap).call({
      from: this.account,
    })
    return result[0][0]
  }
}
